import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup } from '../form/FormGroup';
import useControlled from '../hooks/useControlled';
import RadioGroupContext from './RadioGroupContext';

const RadioGroup = ({
  children,
  defaultValue,
  name,
  onChange,
  value: valueProp,
  orientation
}) => {

  const [value, setValue] = useControlled({
    controlled: valueProp,
    defaultValue
  });

  const handleChange = (event) => {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  return (
    <RadioGroupContext.Provider value={{ name, onChange: handleChange, value }}>
      <FormGroup role="radiogroup" orientation={orientation} gap={false}>
        {children}
      </FormGroup>
    </RadioGroupContext.Provider>
  );
};

RadioGroup.displayName = 'RadioGroup';

RadioGroup.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  defaultValue: PropTypes.any,
  name: PropTypes.string,
  onChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
};

RadioGroup.defaultProps = {
  children: null,
  defaultValue: undefined,
  name: null,
  onChange: null,
  value: undefined,
  orientation: 'vertical'
};

export { RadioGroup };